import { FormObjType } from "DataTypes/Form";

export const AddEditForm: FormObjType[] = [
  {
    id: "input-product-name",
    label: "Product Name",
    placeholder: "Enter Product Name",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "date-product-date",
    label: "Date",
    placeholder: "Select Date",
    boxType: "date",
    boxSize: 4,
    validatetype: "date",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "input-route-name",
    label: "Route Name",
    placeholder: "Enter Route Name",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "input-dose",
    label: "Dose",
    placeholder: "Enter Dose",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "input-dose-unit",
    label: "Dose Unit",
    placeholder: "Enter Dose Unit",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
]